import Api from "./Api";

export default {
  getAllMediaGrid(companyId) {
    return Api().get(`/media-library/${companyId}`);
  },
  getAllMedia(companyId) {
    return Api().get(`/media-library/${companyId}`);
  },
  addMedia(payload) {
    return Api({ hasFile: true }).post(
      `/media-library/${payload.companyId}`,
      payload.data
    );
  },
  bulkDeleteMedia(payload) {
    return Api().post(
      `/media-library/${payload.companyId}/bulk-delete`,
      payload.data
    );
  },
};
